import "./App.css";
import Education from "./Components/Education";
import Technologies from "./Components/Technologies";
import Home from "./Components/Home";
import Project from "./Components/Project";
import Navbar from "./Components/Navbar";
import Footer from "./Components/Footer";
import About from "./Components/About";

function App() {
  return (
    <div>
      <Navbar />
      <Home />
      <About />
      <Project />
      <Technologies />
      <Education />
      <Footer />
    </div>
  );
}

export default App;
